import { render } from "./Answer.vue?vue&type=template&id=3ebd766b&scoped=true"
import script from "./Answer.vue?vue&type=script&lang=js"
export * from "./Answer.vue?vue&type=script&lang=js"

import "./Answer.vue?vue&type=style&index=0&id=3ebd766b&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ebd766b"]])

export default __exports__